import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
const cashImage = require("../../../Assets/Images/canva/nocash.png");
const Cash = () => {
  let { t } = useTranslation();
  return (
    <section id="canvaCash" className="BannerImgFive">
       <Container  fluid className="h-100" >
      <Row className="h-100 align-items-center px-4" >
   
        <Col md={6} sm={12}>
          <div className="text-center h-100">
            <img className="img-fluid w-75" src={cashImage} alt="" />
          </div>
        </Col>
        <Col md={6} sm={12}>
          <div className="h-100 pe-3 py-3">
            <h3 className="heading">
              {/* {t("AboutUs")} */}
              No Cash, No Problem
            </h3>
            <p className="canvaText">
              {/* {t("AboutUsTextFirst")} */}
              Picture yourself stepping into a new restaurant, embracing the
              cashless era. Free from the hassle of a wallet, you can rely on EasyTipping to seamlessly Tip and Go. What's even better? No downloads
              needed. Just scan the QR code, making expressing gratitude for
              excellent service as effortless as a smile.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
    </section>
 
  );
};

export default Cash;
